import React from 'react';
import PropTypes from 'prop-types';
import API, { handleApiError } from '../../../lib/api';
import AdminRewardsTable from './Component';
// import { Styles as ButtonStyles } from '../../common/Button';

import Error from '../../common/ErrorMessage';

function AdminRewardsTableContainer({ ownerId, mortgageId }) {
  /*
   * Delete mortgage is used to delete from the state cache
   * rather than reload data from the API
   */

  // We'll start our table without any data
  const [mortgages, setRewards] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(0);
  const [displayError, setDisplayError] = React.useState();

  const fetchIdRef = React.useRef(0);
  const initialSortBy = [{ id: 'date', desc: true }];

  const fetchData = React.useCallback(
    async ({ pageSize, pageIndex, searchTerm, sortBy, selectedFilter }) => {
      // Give this fetch an ID
      // eslint-disable-next-line no-plusplus
      const fetchId = ++fetchIdRef.current;

      if (fetchId === fetchIdRef.current) {
        // Set the loading state
        setLoading(true);

        const params = {
          pageSize,
          pageIndex,
          status: selectedFilter,
          ownerId: ownerId || searchTerm,
          mortgageId,
        };

        if (sortBy && sortBy.length > 0) {
          params.sortBy = sortBy[0].id;
          params.sortByDesc = sortBy[0].desc;
        }

        const response = await API.get('rewards/', { params }).catch(
          (error) => {
            handleApiError({ error, setDisplayError });
          },
        );

        if (response) {
          setRewards(response.data.data);
          setPageCount(Math.ceil(response.data.totalCount / pageSize));
          setTotalCount(response.data.totalCount);
        }

        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ownerId],
  );

  const filterOptions = [
    {
      label: 'All',
      value: undefined,
    },
    {
      label: 'Pending',
      value: 'PENDING',
    },
    {
      label: 'Confirmed',
      value: 'CONFIRMED',
    },
    {
      label: 'Paid',
      value: 'PAID',
    },
    {
      label: 'Declined',
      value: 'DECLINED',
    },
    {
      label: 'Deleted',
      value: 'DELETED',
    },
  ];

  return (
    <>
      <Error error={displayError} />
      <AdminRewardsTable
        data={mortgages}
        isLoading={loading}
        pageCount={pageCount}
        fetchData={fetchData}
        totalCount={totalCount}
        initialSortBy={initialSortBy}
        filterOptions={filterOptions}
      />
    </>
  );
}

AdminRewardsTableContainer.propTypes = {
  ownerId: PropTypes.string,
  mortgageId: PropTypes.string,
};

AdminRewardsTableContainer.defaultProps = {
  ownerId: undefined,
  mortgageId: undefined,
};

export default AdminRewardsTableContainer;
